import type React from "react"
import "./performance-overview.css"
import TimeRangeDropdown from "../time-range-filter/time-range-dropdown"
import { useState } from "react"
import  analyticsIcon from "../../assets/analyticsIcon.svg"
import EmptyState from "../emptystate"
import { GetImages } from "../../utils/GetImages"
import CurrencyTooltip from "../../components/currencytooltip/CurrencyTooltip";
import SimpleSpinner from "../../components/loader";



export interface PerformanceOverviewProps {
    title?: string
    timeRanges?: string[]
    listings: any[]
    dateFilter?: string;
    onTimeRangeChange?: (newRange: string) => void;
    isLoading?: boolean;
}

const PerformanceOverview: React.FC<PerformanceOverviewProps> = ({
    title = "Performance Overview (Revenue)",
    listings,
    timeRanges = ["Last 12 Month", "Last 6 Month", "Last 3 Month", "This Month"],
    dateFilter = "Last 12 Month",
    onTimeRangeChange,
    isLoading = false,
}) => {

    const [selectedRange, setSelectedRange] = useState(dateFilter);

    const handleTimeRangeChange = (newRange: string) => {
        setSelectedRange(newRange);
        onTimeRangeChange?.(newRange); // Notify parent of the change
    };

    return (
        <div className="performance-overview">
            <div className="performance-overview__header">
                <h2 className="performance-overview__title">{title}</h2>
                <TimeRangeDropdown
                    timeRanges={timeRanges}
                    defaultTimeRange={selectedRange}
                    onTimeRangeChange={handleTimeRangeChange}
                    className="my-custom-dropdown"
                />
            </div>

            {isLoading ? (
                <div className="performance-overview__loader">
                    <SimpleSpinner myClassName="Icon40" />
                </div>
            ) : listings?.length ? (
                <div className="performance-overview__listings">
                    {listings.map((listing, index) => (
                        <div key={listing?.propertyId} className="property-listing">
                            <div className="property-listing__image-container">
                                <img
                                    src={listing?.mainImageBase64
                                        ? `data:image/jpeg;base64,${listing?.mainImageBase64}`
                                        : GetImages.PropertyPlaceholder}
                                    alt={listing.address}
                                    className="property-listing__image"
                                />
                            </div>

                            <div className="property-listing__details">
                                <h3 className="property-listing__address">{listing?.streetAddress}</h3>
                                <p className="property-listing__type">{listing?.formatted?.PropertyType}</p>
                            </div>

                            <div className="property-listing__metrics">
                                <div className="property-listing__revenue">
                                    <CurrencyTooltip
                                        content={listing?.formatted?.RevenueRaw || listing?.formatted?.Revenue}
                                        formatted={listing?.formatted?.Revenue}
                                    >
                                        <span>{listing?.formatted?.Revenue ? `[[currency]]${listing?.formatted?.Revenue}` : "N/A"}</span>
                                    </CurrencyTooltip>
                                </div>
                                {listing?.formatted?.Percentage &&
                                    <div className="property-listing__percentage">{listing?.formatted?.Percentage}%</div>
                                }
                            </div>

                            {index < listings.length - 1 && <div className="property-listing__divider" />}
                        </div>
                    ))}
                </div>
            ) : (
                <EmptyState
                    icon={GetImages.emptyStateData}
                    heading={"No Data Found "}
                    isButton={false}
                    isBorder={false}
                />
            )}
        </div>
    )
}

export default PerformanceOverview
